export const COMPANY_DOMAIN_LEVEL = ["backoffice", "app"];

export const COMPANY_LEVEL = {
  SYSTEM: "system",
  COMPANY: "company",
  STAFF: "staff",
};

export const extractUserReferralFromUrl = (url = "") => {
  const pageUrl = url;
  const locationPath = pageUrl.split("/");

  // remove '/referral' in pathname
  const referralInformation = locationPath.splice(2);
  const [referralName = "", referralCode = ""] = referralInformation;
  return [referralName, referralCode];
};

export const extractBrokerReferralFromUrl = (url = "") => {
  const pageUrl = url;
  const locationPath = pageUrl.split("/");
  const isBrokerPage = locationPath[1] === "broker";
  if (isBrokerPage) {
    const referralInformation = locationPath.splice(2);
    const [staffCode = ""] = referralInformation;
    return [isBrokerPage, staffCode];
  }
  return [isBrokerPage, ""];
};

export const getPathParam = (index) => {
  if (typeof window !== "undefined") {
    const pathSegments = window.location.pathname.split("/").filter(Boolean);
    return pathSegments[index] || null;
  }
  return null;
};

export const getCurrentPath = () => {
  return typeof window !== "undefined" && window.location.pathname;
};
export const getCurrentLocation = () => {
  return typeof window !== "undefined" && window.location;
};

export const extractURLLevel = () => {
  let companyDomainLevel = null;
  let companyDomain = null;
  if (typeof window !== "undefined") {
    const [firstLevel, secondLevel] = window.location.hostname
      .split(".")
      .slice(0, 2);

    const isSystemLevel = COMPANY_DOMAIN_LEVEL.includes(firstLevel);
    const isCompanyLevel = COMPANY_DOMAIN_LEVEL.includes(secondLevel);
    const isStaffLevel =
      !COMPANY_DOMAIN_LEVEL.includes(firstLevel) &&
      !COMPANY_DOMAIN_LEVEL.includes(secondLevel);
    if (isSystemLevel) {
      companyDomainLevel = COMPANY_LEVEL.SYSTEM;
      companyDomain = firstLevel;
    }
    if (isCompanyLevel) {
      companyDomainLevel = COMPANY_LEVEL.COMPANY;
      companyDomain = firstLevel;
    }
    if (isStaffLevel) {
      companyDomainLevel = COMPANY_LEVEL.STAFF;
      companyDomain = secondLevel;
    }
  }
  return {
    companyDomainLevel,
    companyDomain,
  };
};

export const getcompanyDomain = () => {
  if (typeof window !== "undefined") {
    const { companyDomain, companyDomainLevel } = extractURLLevel();
    if (companyDomainLevel === COMPANY_LEVEL.SYSTEM) {
      return null;
    }
    return companyDomain;
  }
  return "";
};

const extractUrlValue = (url = "") => {
  const pageUrl = url;
  const locationPath = pageUrl.split("/");
  return [
    locationPath[locationPath.length - 2],
    locationPath[locationPath.length - 1],
  ];
};

export const getValueFromURLWithKey = (key, url = "") => {
  const pageUrl = url;
  const match = pageUrl.match(`[?&]${key}=([^&]+)`);
  return match ? match[1] : null;
};

export default extractUrlValue;
